import { Icon } from '../../icons/Icon.jsx'
import { useWidgetContext } from './context.js'
import { asList } from './primitives.jsx'
import w from './widgets.module.css'

/**
 * #10 Clarify chooser (ask_clarification). The answer ends here; a click sends
 * the option as the next question, and anything typed in the composer instead
 * answers it as free text. Once answered it collapses to one line.
 */
export function Clarify({ input, block, reply, canAnswer }) {
  const { onAsk, readOnly } = useWidgetContext()
  const options = asList(input.options).filter((o) => o?.label)

  if (reply) {
    return (
      <div className={w.answered}>
        <Icon name="check" size={14} strokeWidth={1.8} />
        <span>{input.question}</span>
        <span aria-hidden="true">→</span>
        <span className={w.answerChip}>{reply}</span>
      </div>
    )
  }

  const active = canAnswer && block.complete
  return (
    <div className={w.clarify} role="group" aria-label="Clarifying question">
      <div className={w.clarifyQ}>{input.question}</div>
      <div className={w.opts}>
        {options.map((option) => (
          <button
            key={option.label}
            type="button"
            className={w.opt}
            disabled={!active}
            onClick={() => onAsk?.(option.label)}
          >
            <span>{option.label}</span>
            {option.description ? <small>{option.description}</small> : null}
          </button>
        ))}
      </div>
      {active && input.allow_free_text !== false ? (
        <div className={w.muted}>Or type your answer in the box below.</div>
      ) : null}
      {readOnly ? <div className={w.muted}>Not answered in this conversation.</div> : null}
    </div>
  )
}
